import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background-image: url("https://wallpaperaccess.com/full/380911.jpg");
  background-size: cover;
  overflow: auto;

  .head {
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;

    div {
      display: flex;
      align-items: center;

      h1 {
        margin: 0;
      }

      svg {
        margin-right: 20px;
        font-size: 30px;
        cursor: pointer;
        color: #fff;
        transition: 0.3s;

        :hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .the-battle {
    width: 300px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      font-size: 25px;
    }
  }

  .user-info {
    min-width: 90%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .actions {
    min-width: 40%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .attacks {
    width: 560px;
    max-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .attack-tittle {
      /* text-shadow: 1px 1px 10px rgba(0, 0, 0, 1); */
      font-weight: 800;
      font-size: 20px;
      text-decoration: underline;
    }

    ul {
      overflow-x: scroll;
      width: 100%;
      height: 220px;
      padding: 0;
      display: flex;

      div {
        margin-bottom: 0;
        min-width: 185px;
        min-height: 175px;
        margin-right: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
          white-space: nowrap;
          font-family: monospace;
          width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: capitalize;
          margin: 0;
          font-size: 1rem;
        }
      }
    }
  }

  .status {
    width: 250px;

    p {
      margin: 6px 0;
    }
  }

  .use {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  div {
    position: initial;
    img {
      border-radius: 25px;
      max-width: 200px;
      max-height: 200px;
      margin: 0 auto;
    }

    p {
      display: flex;
      justify-content: space-between;

      button {
        background: #e8a22a;
        border: none;
        border-radius: 3px;
        border-top: #e8d52a 1px solid;
        border-bottom: #8c6804 1px solid;
      }
    }
  }

  .active-false {
    background-color: #9fa19f;
    border-top: 1px solid #9fa19f;
    cursor: initial;
    color: #4c4f4d;
  }

  .active-true:hover {
    background-color: #a86b32;
  }

  @media (max-width: 1000px) {
    .actions {
      min-width: 70%;
      justify-content: space-around;
    }
  }

  @media (max-width: 570px) {
    align-items: flex-start;
    justify-content: flex-start;
    .actions {
      min-width: 100%;
    }
  }
`;
